import React, { useMemo } from 'react'
import styles from '../Home.module.less'
import { HeaderTabs } from 'Components/common/HeaderTabs/HeaderTabs'
import { TaskQueuesTab } from 'Pages/Home/tabs/tasks/TaskQueuesTab.tsx'
import { FeedbackTab } from 'Pages/Home/tabs/tasks/FeedbackTab.tsx'
import SavedTasksScreen from 'Components/common/SavedForLater/SavedTasksScreen.tsx'
import { useUserProfile } from 'shared/auth/hooks/use-user-profile/useUserProfile'
import { FEEDBACK_TAB_HIDDEN_EMAIL_DOMAIN } from 'Constants/page.constants'

export const TasksTab: React.FC = () => {
    const { userProfile } = useUserProfile()
    const showFeedbackTab = !userProfile.user.email
        .trim()
        .toLowerCase()
        .endsWith(FEEDBACK_TAB_HIDDEN_EMAIL_DOMAIN)

    const tabItems = useMemo(
        () => [
            {
                key: 'available-tasks',
                label: 'Available Tasks',
                children: <TaskQueuesTab />,
            },
            ...(showFeedbackTab
                ? [
                      {
                          key: 'feedback',
                          label: 'Feedback',
                          children: <FeedbackTab />,
                      },
                  ]
                : []),
            {
                key: 'tasks-saved-for-later',
                label: 'Tasks Saved For Later',
                children: <SavedTasksScreen />,
            },
        ],
        [showFeedbackTab]
    )

    return (
        <div className={styles['tasks-tab']}>
            <HeaderTabs items={tabItems} />
        </div>
    )
}
